export default __webpack_public_path__ + "static/media/kuda-logo.8f11085d.svg";